import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {ToastrService} from "ngx-toastr";
import {Subscription} from "rxjs";
import {Message} from '../../../../../../../core/class/message';
import {WarningComponent} from '../../../../../../../shared/components/warning/warning.component';
import {NotificationService} from '../../../../../../../core/services/notification.service';
import {DocumentService} from '../../../../../../../core/services/document.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-modal-money-transfer',
  templateUrl: './modal-money-transfer.component.html',
  styleUrls: ['./modal-money-transfer.component.scss']
})
export class ModalMoneyTransferComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private message: Message,
    private toastr: ToastrService,
    private documentService: DocumentService,
    public dialogRef: MatDialogRef<ModalMoneyTransferComponent>,
    public notificationService: NotificationService,
    private router: Router
  ) {
    // this.document = data.document;

  }

  document = {
    id: 0,
    reason: ''
  };
  formChangesSubscription: Subscription;

  @ViewChild('f', {static: false}) ngForm: NgForm;
  public isFormChanging: boolean;
  private success: boolean;

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }
  ngOnInit() {
    this.notificationService.subscribeErrorService();
  }

  textValidator() {
    let mesage;
    if (Number(this.document.reason) > Number(this.data.num)) {
      mesage = this.message.getMessage('validation.fixed_money_max');
    } else if (Number(this.data.num) - Number(this.document.reason) < Number(this.data.configMoney)) {
      mesage = this.message.getMessage('validation.fixed_money_max_1').replace('{0}', ((Number(this.data.num) - Number(this.data.configMoney)).toLocaleString('en-US')) + '')
    }
    return  mesage;
  }
  textMaxMoneySMS() {
    const mesage = this.message.getMessage('validation.fixed_money_sms_1').replace('{0}', (this.data.num.toLocaleString('en-US')) + '') + this.message.getMessage('validation.fixed_money_tsa').replace('{0}', (this.data.configMoney.toLocaleString('en-US')) + '');
    return mesage;
  }
  textMaxMoneyTSA() {
    const mesage =this.message.getMessage('validation.fixed_money_tsa_1').replace('{0}', (this.data.num.toLocaleString('en-US')) + '') + this.message.getMessage('validation.fixed_money_tsa').replace('{0}', (this.data.configMoney.toLocaleString('en-US')) + '');
    return mesage;
  }

  validationLengthMoney (reason: any, num: any) {
    if (Number(reason) > Number(num)) {
      return true;
    }
    return false;
  }

  validationMaxMoney (reason: any, num: any, config: any) {
    if (
      Number(reason) > 0 && Number(num) >= Number(config) && ((Number(num) - Number(reason)) < Number(config))
    ) {
      return true;
    }
    return false;
  }

  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  moneyTransferCts(){
    this.documentService.moneyTransferCts(this.document.reason).subscribe(rs => {
      if (rs.success) {
        this.success = true;
        this.toastr.success(rs.message);
        this.dialogRef.close(this.success);
        this.router.navigate(['/home-enterprise/analysis-report/']);
      } else {
        this.success = false;
        this.toastr.error(rs.message);
      }
       });
  }

  moneyTransfer() {
    this.documentService.moneyTransfer(this.document.reason).subscribe(rs => {
   if (rs.success) {
     this.success = true;
     this.toastr.success(rs.message);
     this.dialogRef.close(this.success);
     this.router.navigate(['/home-enterprise/analysis-report/']);
   } else {
     this.success = false;
     this.toastr.error(rs.message);
   }
    });
  }
  numberOnly(event: any): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if((charCode > 31 && charCode <= 43) || (charCode >= 43 && charCode < 48) || (charCode > 57)){
      return false;
    }
    return true;
  }

  onPasteNumber(event: ClipboardEvent): boolean {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData("text");
    if (!this.isNum(pastedText)) {
      return false;
    }
    return true;
  }

  isNum(val: any) {
    return !isNaN(val);
  }

  onBlurEvent(event: Event): void {
    this.document.reason = this.document.reason.replace(/^0+/, '');
  }
}
